import React, { Component } from 'react';
import imgStandards from '../images/ems-standards.png';
import '../css/imgStyles.css';

class Standards extends Component {
    
    render() {
      return (
        <React.Fragment>
            <p id="title">EMS Customer Service Standards</p>
            
            <p>
                In ESM we believe that efficient Customer Service is a key for success. 
                We have developed our customer service procedures to ensure that consistent 
                quality of service is delivered to our end-users. 
                Our general client - ESM communication process is illustrated in the graph below:
            </p>

            <div class="imgDivStyle fadeInStyle-3">
                <img src={imgStandards} />
            </div>

            <p>
                We emphasize on the need for efficient customer service as we know the 
                importance of proper communication with our clients. 
                The more the communication is clear and simple the less hassle the client 
                face and therefore more satisfaction.  
            </p>
        </React.Fragment>
      );
   }
}

export default Standards;